import React from 'react'
import { SurveyAnswersGroup } from './surveyanswers-group'
import { YesNo } from './surveyanswers-yesno'
import { Text } from './surveyanswers-text'
import { UploadMedia } from './surveyanswers-upload'
import { OrderImages } from './surveyanswers-orderimages'
import { ANumber } from './surveyanswers-number'
import { Punctuation } from './surveyanswers-punctuation'

const QuestionType = {
  'yesno': YesNo,
  'text': Text,
  'uploadmedia': UploadMedia,
  'orderimages': OrderImages,
  'number': ANumber,
  'punctuation': Punctuation
}

export const SurveyAnswers = props => {

  const Answer = QuestionType[props.parent.attribs['data-type']]
  
  return <div 
    { ...props.attribs }
  >
    {
      props.children.length ?
      <SurveyAnswersGroup { ...props } />
      :
      <Answer { ...props } />
    }
  </div>
}
